module.exports = __webpack_public_path__ + "media/images/award-badges-kr-c41067bcfd1e0ea135d0b90b57d249e6.svg";